import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {catchError} from 'rxjs/operators';
import {HttpRequestErrorHandler} from '@rbaip/ui-component';
import {appConfig} from '../app.config';

@Injectable({
  providedIn: 'root'
})
export class ItemSummaryRbaItemInfoService {

  constructor(private http: HttpClient) {
  }

  public getRBItemInfo(assetGuid: string): Observable<any> {
    const url = `/api/rba-items/${assetGuid}/info`;
    return this.http.get<any>(url,  appConfig.httpOptions)
      .pipe(
        catchError(HttpRequestErrorHandler.handleError('getRBItemInfo', false))
      );
  }
}
